import { Download } from "lucide-react";
import { toast } from "sonner";
import { errMsg, fmtDate, download } from "../../../lib/api";
import { StatusBadge } from "../../StatusBadge";
import { Button } from "../../ui/button";

export function Report({ r, testId }) {
  return (
    <div className="divide-y divide-slate-800 border border-slate-800 rounded-lg" data-testid={testId}>
      {r.checks.map((c) => (
        <div key={c.id} className="p-3 flex justify-between gap-3 text-sm" data-testid={`${testId}-check-${c.id}`}>
          <div><p className="text-slate-200">{c.label}</p>{c.detail && <p className="text-xs text-slate-500">{c.detail}</p>}</div><StatusBadge status={c.status} />
        </div>
      ))}
    </div>
  );
}

const LABEL = { interior_pdf: "Interior PDF", picture_interior_pdf: "Picture book interior PDF", picture_epub: "Picture book Kindle ebook (fixed layout)", cover_pdf: "Cover PDF", docx: "Formatted DOCX", zip: "Audiobook package" };

export function OutputCard({ o }) {
  return (
    <div className="panel p-5 space-y-3" data-testid={`output-${o.id}`}>
      <div className="flex flex-wrap justify-between gap-3 items-center">
        <div><p className="eyebrow">{o.edition === "publish_kit" ? "Publish Kit" : LABEL[o.type] || o.type}</p><p className="font-mono text-sm break-all">{o.filename}</p>
          <p className="text-xs text-slate-500">{(o.size / 1024).toFixed(1)} KB{o.version_number ? ` · from v${o.version_number}` : ""}{o.page_count ? ` · ${o.page_count} pages` : ""}{o.gutter_in ? ` · gutter ${o.gutter_in}"` : ""} · {fmtDate(o.created_at)}</p></div>
        <div className="flex gap-2 items-center"><StatusBadge status={o.report.overall} testId={`output-overall-${o.id}`} />
          <Button size="sm" variant="outline" className="border-slate-700" onClick={() => download(`/edition-outputs/${o.id}/file`, o.filename).catch((e) => toast.error(errMsg(e)))} data-testid={`output-download-${o.id}`}><Download size={13} className="mr-1" />Download</Button></div>
      </div>
      <Report r={o.report} testId={`report-${o.id}`} />
    </div>
  );
}
